<template>
  <section class="lm-thumbnail">
    <section class="lm-thumbnail_content"><img :class="['is_block']" :src="src" /></section>
    <section :class="['lm-thumbnail_mock', { 'is_opacity': visible }]">
      <slot></slot>
    </section>
  </section>
</template>

<style scoped lang="scss">
@import '@/assets/styles/variable.scss';

.lm-thumbnail {
  position: relative;
  overflow: hidden;
  height: 832.72px;
  &_content {
    img {
      width: 100%;
      transition: all $transitionDuration ease;
    }
  }
  &_mock {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, .48);
    transition: all .48s;
    opacity: 0;
    &.is_opacity {
      opacity: 1;
    }
  }
}
</style>

<script>
export default {
  props: {
    src: {
      type: String,
      require: true
    },
    scale: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  // watch: {
  //   visible(val) {
  //     console.log('visible', val)
  //   }
  // },
}
</script>